var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Seed"},[_c('AppModal',[_c('button',{attrs:{"type":"button"},on:{"click":function($event){$event.preventDefault();return _vm.seed($event)}}},[_vm._v("Seed")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }